import { ListResult } from '../../ts/fetchers/ListResult';
import { ISliceable } from '../../ts/models/ISliceable';

export module StoreHelpers {

  export function getAll<T>(sliceable: ISliceable<T>): Q.Promise<T[]> {

    const deferred = Q.defer<T[]>();

    const blockSize = 1000;
    let allItems: T[] = [];

    function fetchBlock(start: number) {
      sliceable.getSlice(start, blockSize)
        .then((result:ListResult<T>) => {
          allItems = allItems.concat(result.items);
          if (allItems.length < result.total) {
            fetchBlock(start + blockSize);
          } else {
            deferred.resolve(allItems);
          }
        });
    }

    fetchBlock(0);

    return deferred.promise;

  }

}
